import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetProductsSlice = createSlice({
    name: "getProducts",
    initialState,
    reducers: {
        getProductsRequest(state) {
            state.loading = true;
        },
        getProductsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getProductsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getProductsRequest,
    getProductsRequestSuccess,
    getProductsRequestError,
} = GetProductsSlice.actions;

export default GetProductsSlice.reducer;
